module.exports = __webpack_public_path__ + "static/img/cover.829ff0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/a-view-outside/cover.png
// module id = kx7e
// module chunks = 0